export enum CampaignStateEnum {
  PREPARE_DATA = 1,
  PUBLISH_DATE = 2,
  COMPLAINT_DATE_OF_DISPATCH = 3,
  RECOURSE_CLAIM_DATE_OF_DISPATCH = 4,
  NEGOTIATED = 5,
  DUE_DATE_REVENUES = 6,
  COMPLETELY_BOOKED = 7,
  CANCELLED_STOPPED_CHANGED = 8,
  NO_SUPPLIER_FAULT = 9,
  NEW_CAMPAIGN = 10,
}
